import { colord } from 'colord';

export const generateGradient = (baseColor: string): string => {
  const steps = [0.21, 0.41, 0.451, 0.61, 0.74, 0.87, 1];

  const gradientStops = steps.map((step, i) => {
    const darkened = colord(baseColor)
      .darken(i * 0.03)
      .alpha(0.75);

    return `${darkened.toRgbString()} ${Math.round(step * 100)}%`;
  });

  return `linear-gradient(180deg, ${gradientStops.join(', ')})`;
};
